import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import Constantes from "../../constantes";

function ContraCambiada() {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [cambioRealizado, setCambioRealizado] = useState(false);
    const [searchParams] = useSearchParams();

    useEffect(() => {

        const email_url = searchParams.get('email');
        if (email_url) {
            setEmail(email_url);
        }

        const token_url = searchParams.get('token');
        if (token_url) {
            setToken(token_url);
        }
        
    }, [searchParams]);

    const haCambiado = useCallback(async () => {

        try {
            const respuesta = await fetch(Constantes.RUTA_API + '/usuarios/restablecer', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email, token: token }),
            });
            const data = await respuesta.json();
            alert(data.message);
            console.log(data);
            return data.error === false ;
        } catch (error) {
            console.error('Error al cambiar la contraseña:', error);
            alert('Hubo un error al cambiar la contraseña');
        }

        return false;

    }, [email, token]);

    useEffect(() => {
        if (!email || !token) return;

        console.log(email, token);

        const comprobarCambio = async () => {
            console.log("Comprobando cambio de contraseña para ", email, " con token ", token);
            const cambio = await haCambiado();
            setCambioRealizado(cambio);
        };

        comprobarCambio();
    }, [email, token, haCambiado]);


    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">
                <div className="mb-4 mt-4 text-center">
                    {cambioRealizado && <>
                        <h1 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.4rem)' }}>Tu cuenta "{email}" ha cambiado su contraseña satisfactoriamente</h1>

                        <br />

                        <h3>Disfruta de la aplicación y para cualquier duda no dudes en contactarnos en <a href='mailto:yourny.oficial+consultas@gmail.com'>yourny.oficial@gmail.com</a></h3>

                        <br />

                        <br />

                        <button type="button" className="my-4 btn btn-primary" onClick={() => { window.location.href = "/login" }}>Ir a inicio de sesión</button>
                    </>
                    }
                    {!cambioRealizado &&
                        <>
                            <h1 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.4rem)' }}>Ooops.... parece que algo no ha funcionado como debería</h1>
                            <br />
                            <h3>Cuentanoslo en <a href='mailto:yourny.oficial+bug_cambio_contra@gmail.com'>yourny.oficial@gmail.com</a></h3>
                            <p>Necesitaremos que nos proporciones la siguiente información en el mensaje</p>
                            <br />
                            <p>Identificador del problema: "{token}"</p>
                            <p>Email de solicitud: "{email}"</p>
                        </>
                    }

                </div>
            </div >


            <title>Cambio de contraseña</title>

        </>

    );
}

export default ContraCambiada;